<script lang="ts">
import {
  inject,
  computed,
  defineComponent,
  ref,
  PropType,
  reactive,
  toRefs,
  watch,
  onMounted,
} from "vue";
import { submitSuccessEmitter } from "@/utils/emitter";

export default defineComponent({
  isGlobal: true,
  name: "QualityMaterialWrapper",
  components: {},
  props: {},
  setup(props, { emit }) {
    // const parentState = (inject("parentState") || {}) as any;
    const tableHeight = ref(0);
    // watch(
    //   () => parentState.tableHeight,
    //   (n) => {
    //     tableHeight.value = n;
    //     // // console.log("parentState.tableHeight", n);
    //   },
    //   { immediate: true }
    // );
    return {
      tableHeight,
    };
  },
});
</script>
<template>
  <div class="file-upload-table">
    <slot :tableHeight="tableHeight"></slot>
  </div>
</template>
<style lang="less" scoped></style>
